import styled from 'styled-components';

export const Text = styled.h2`
  color: #7e9395;
  margin-bottom: 1rem;
  font-weight: 600;
`;
